var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3ExternalSpotOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v62h62V7H7zm58 58H11V11h17v19.56a2.216 2.216 0 000 .44v.13c.03.096.067.19.11.28l.07.14.15.22c.036.04.07.084.1.13l.21.19.11.09c.094.066.195.123.3.17h.07c.134.06.275.103.42.13h.43c.2.003.4-.027.59-.09a1.76 1.76 0 00.56-.29 2.15 2.15 0 00.88-1.62V11h33v54zM54 38h6v4h-6v-4zm-1.77 10.89L56.56 53l-2.76 2.93-4.34-4.15 2.77-2.89zM39 54h4v7h-4v-7zm-7.17-17.72a6 6 0 004.17-5.8V22.1L47.28 32h8.5L33 55.92v-8.25l-9.94-9.09L15 31.16l9-8.89v8.29a6 6 0 007.83 5.72z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_External_spot_on.1f752be4.svg";
export { SvgA3ExternalSpotOn as ReactComponent };